import { render } from "./NotFound.vue?vue&type=template&id=51e29c22&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=51e29c22&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e29c22"]])

export default __exports__